import { createAction, props } from '@ngrx/store';
import { PlantListInterface } from 'src/app/pages/record/interfaces';

export const loadPlantListCompany = createAction('[PlantListCompany] Load');
export const loadPlantListCompanySuccess = createAction(
  '[PlantListCompany] Load Success',
  props<{ key: string; plants: PlantListInterface[] }>(),
);
export const loadPlantListCompanyFailure = createAction(
  '[PlantListCompany] Load Failure',
  props<{ error: string; key: string }>(),
);
export const resetPlantListCompany = createAction('[PlantListCompany] Reset');
export const refreshPlantListCompany = createAction('[PlantListCompany] Refresh');
